import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconSubscript24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconSubscript24"
            aria-hidden="true"
            {...props}
        >
            <g fill="none">
                <g clipPath="url(#Subscript24)">
                    <path
                        fill="currentColor"
                        fillRule="evenodd"
                        d="M14.6 7.404a.75.75 0 1 0-1.06-1.06l-4.597 4.595-4.596-4.595a.75.75 0 1 0-1.06 1.06L7.883 12l-4.596 4.596a.75.75 0 1 0 1.06 1.06l4.596-4.595 4.596 4.596a.75.75 0 0 0 1.06-1.061L10.005 12z"
                        clipRule="evenodd"
                    />
                    <path
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeWidth={1.5}
                        d="m18.68 15.297 1.576-.357v4.4"
                    />
                </g>
                <defs>
                    <clipPath id="Subscript24">
                        <path fill="#fff" d="M0 0h24v24H0z" />
                    </clipPath>
                </defs>
            </g>
        </svg>
    );
}
export default memo(IconSubscript24);
